<template>
  <div class="q_mar_b100px">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <!--			<van-swipe-item>-->
      <!--				<van-image width="100%" fit="cover" :src="goods.backPic" />-->
      <!--			</van-swipe-item>-->
      <van-swipe-item :key="item.id" v-for="(item, index) in backPic">
        <van-image width="100%" fit="cover" :src="convertImg(item)"/>
      </van-swipe-item>
    </van-swipe>
    <div class="q_pad_lr15px">
      <div class="q_text_l q_bold q_mar_t20px q_color_red">{{ goods.integral }}积分
        <span class="q_flo_right q_text_s q_color_gray"
              style="font-weight: 400;">每个账户限兑 {{ goods.boundsNumber }} 次</span>
      </div>
      <div class="q_text_m q_bold q_mar_t10px q_mar_b20px">{{ goods.name }}</div>
      <div class="q_text_l q_bold q_mar_t20px q_bor_top q_pad_tb20px">商品详情</div>
      <div class="q_artdea">
        <!--        <p><img src="../../assets/image/act.png" /></p>-->
        <div class="ql-editor" v-html="goods.content"></div>
        <!--				<p>活动时间：4月18日 上午8点-下午5点</p>-->
        <!--				<p>活动地点：山东省烟台市招远市</p>-->
        <!--				<p>诚邀嘉宾：所有有意向的志愿者朋友</p>-->
        <!--				<p>参加路线：交通自理 建议绿色出行 地铁10号线 纪家庙地铁站 B东北口出</p>-->
        <!--				<p>（提供中午餐食）</p>-->
        <!--				<p>早7点30开始签到入场</p>-->
        <!--				<p><img src="../../assets/image/act.png" /></p>-->
      </div>
    </div>
    <van-goods-action>
      <van-goods-action-button v-if="!boundsNumber" type="danger" color="#FF5733" text="立即兑换" @click="goToFeedback()"/>
      <van-goods-action-button v-if="boundsNumber" type="danger" disabled color="#FF5733" text="已达兑换上限"/>
    </van-goods-action>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {listGoodsById} from "@/api/goods";
import {addIntegral, listIntegral} from "@/api/integral";
import {Dialog} from "vant";
import {getLoginUser} from "@/api/login";


export default {
  name: 'Exchangdea',
  props: {
    msg: String
  },

  data() {
    return {
      textValue: '',
      logoPath: '',
      showQrCode: false,
      boundsNumber: false,
      show: false,
      goodsId: '',
      goods: {},
      user: {},
      backPic: []
    }
  },
  created() {
    this.goodsId = this.$route.query.id;
    getLoginUser().then(res => {
      this.user = res.data
    }).then(() => {
      this.init()
    })
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.$modal.loading()
      //获取活动详情信息
      listGoodsById(this.goodsId).then((res) => {
        this.goods = res.data
        this.backPic = res.data.backPic.split(',')
      }).then(() => {
        //判断最大限制兑换次数
        var params = {
          userId: this.user.id,
          goodsId: this.goods.id,
          isTask: "null"
        }
        listIntegral(params).then(res => {
          if (this.goods.boundsNumber <= res.total) {
            this.boundsNumber = true
          }
        })
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToFeedback() {
      Dialog.confirm({
        title: '提示', message: '确定兑换该商品吗', confirmButtonText: '兑换', cancelButtonText: '取消'
      }).then(() => {
        //判断最大限制兑换次数
        var params = {
          userId: this.user.id,
          goodsId: this.goods.id
        }

        var params = {
          userId: this.user.id,
          goodsId: this.goodsId,
          type: '1',
          score: this.goods.integral,
          cdType: '0'
        }
        //添加积分变化记录
        addIntegral(params).then(res => {
          if (res.code == '200') {
            this.$modal.success("兑换成功")
            setTimeout(() => {
              this.$router.push({
                path: '/mine/Exchangedea', query: {id: res.data}
              });
            }, 1000);

          }
        })

      }).catch(() => {
      });


    },
  },
}
</script>
<style scoped="scoped">
>>> .van-swipe {
  font-size: 0;
}

.van-swipe .van-image {
  height: 345px;
}

.q_acti img {
  height: 14px;
}

.van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-popup {
  border-radius: 6px;
}
</style>
